module.exports = __webpack_public_path__ + "static/media/live-streaming-icon.7cf32c3b.svg";